import moment from "moment";
import Common from "@/util/common.js";
 
const state = {
  termsServiceFlag: false,
  importFlag: false,
  exportFlag: false,
  processingFlag: false,
  templateFlag: false,
  completeFlag: false,
  confirmFlag: false,
  deleteFlag: false,
  uploadFlag: false,
  uploadDocFlag: false,
  updateDocFlag: false,
  deleteDocFlag: false,
  notificationFlag: false,
  reNotificationFlag: false,
  printFlag: false,
  BopUserName: "",
  currentUserName: "",
  maintenance: "",
  closeType: 0,
  // リクエスト中フラグ
  pending: false,
  modalCount: 0,
  uploadDlgFlag: false,
  uploadCmfDlgFlag: false,
  // No8データ容量表示領域更新対応
  dataSpaceUsedChangeFlag: false,
  scrollTop:""
};
const getters = {
  getCloseType(state) {
    return state.closeType;
  },
  isTermsServiceShow(state) {
    return state.termsServiceFlag;
  },
  isTemplateShow(state) {
    return state.templateFlag;
  },
  isImportShow(state) {
    return state.importFlag;
  },
  isExportShow(state) {
    return state.exportFlag;
  },
  isProcessShow(state) {
    return state.processingFlag;
  },
  isCompleteShow(state) {
    return state.completeFlag;
  },
  isConfirmShow(state) {
    return state.confirmFlag;
  },
  isDeleteShow(state) {
    return state.deleteFlag;
  },
  isUploadShow(state) {
    return state.uploadFlag;
  },
  isUploadDocShow(state) {
    return state.uploadDocFlag;
  },
  isUpdateDocShow(state) {
    return state.updateDocFlag;
  },
  isDeleteDocShow(state) {
    return state.deleteDocFlag;
  },
  getMaintenance(state) {
    return state.maintenance;
  },
  isNotificationShow(state) {
    return state.notificationFlag;
  },
  isReNotificationShow(state) {
    return state.reNotificationFlag;
  },
  isPrintShow(state) {
    return state.printFlag;
  },
  isBopUserName(state) {
    return state.BopUserName;
  },
  isPending(state) {
    return state.pending;
  },
  getModalCount(state) {
    return state.modalCount;
  },
  isUploadDlgShow(state) {
    return state.uploadDlgFlag
  },
  isUploadCmfDlgShow(state) {
    return state.uploadCmfDlgFlag
},
};
const mutations = {
  setCloseType(state, payload) {
    state.closeType = payload;
  },
  termsServiceDialogue(state, payload) {
    state.termsServiceFlag = payload;
  },
  importDialogue(state, payload) {
    state.importFlag = payload;
  },
  exportDialogue(state, payload) {
    state.exportFlag = payload;
  },
  processDialogue(state, payload) {
    state.processingFlag = payload;
  },
  templateDialogue(state, payload) {
    state.templateFlag = payload;
  },
  completeDialogue(state, payload) {
    state.completeFlag = payload;
  },
  confirmDialogue(state, payload) {
    state.confirmFlag = payload;
  },
  deleteDialogue(state, payload) {
    state.deleteFlag = payload;
  },
  uploadDialogue(state, payload) {
    state.uploadFlag = payload;
  },
  uploadDocDialogue(state, payload) {
    state.uploadDocFlag = payload;
  },
  updateDocDialogue(state, payload) {
    state.updateDocFlag = payload;
  },
  deleteDocDialogue(state, payload) {
    state.deleteDocFlag = payload;
  },
  fetchMaintenance(state, payload) {
    state.maintenance = moment()
      .add(payload, "minute")
      .format("HH:mm");
  },
  notificationDialogue(state, payload) {
    state.notificationFlag = payload;
  },
  reNotificationDialogue(state, payload) {
    state.reNotificationFlag = payload;
  },
  printDialogue(state, payload) {
    state.printFlag = payload;
  },
  setBopUserName(state, payload) {
    state.BopUserName = payload;
  },
  setCurrentUserName(state, payload) {
    state.currentUserName = payload;
  },
  setPendingStatus(state, payload) {
    state.pending = payload
  },
  uploadDialogue(state, payload) {
    state.uploadDlgFlag = payload;
  },
  increaseModalCount(state, payload) {
    state.modalCount++;
    if (state.modalCount > 0) {
      //子画面が表示されるときに、親画面のスクロールを表示制御
      document.body.style.overflow = "hidden";
    }
  },
  decreaseModalCount(state, payload) {
    if (state.modalCount > 0) {
      state.modalCount--;
    } else {
      state.modalCount = 0;
    }
    if (state.modalCount === 0) {
      //子画面が表示されるときに、親画面のスクロールを表示制御
      document.body.style.overflow = "";
    }
  },
  uploadCmfDialogue(state, payload) {
    state.uploadCmfDlgFlag = payload;
  },
  // No8データ容量表示領域更新対応
  updateDataSpaceUsedChangeFlag(state,payload){
    state.dataSpaceUsedChangeFlag = payload
  },
  handleBodyScrollOnModalStateChange(state, isShow){
    let isMobile = Common.isMobile()
    if(isMobile){
      if(isShow){
          state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          document.body.style.overflow = "hidden"
          document.body.style.position = "fixed"
      } else {
          document.body.style.overflow = "auto"
          document.body.style.position = "relative"
          window.scrollTo(0,state.scrollTop)
          state.scrollTop = 0
      }
    }
  
  }
};
const actions = {
  showProcessDialogue({ commit }, data) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit("processDialogue", !data);
        commit("completeDialogue", data);
        setTimeout(() => {
            resolve(true);
        }, 500);
      }, 500);
    });
  },
  showCompleteDialogue({ commit }, data) {
    setTimeout(() => {
      commit("completeDialogue", data);
    }, 2);
  },
  showCollectionRequestModal({ commit }, data) {
    commit("notificationDialogue", data);
  },
  showAgainCollectionRequestModal({ commit }, data) {
    commit("reNotificationDialogue", data);
  },
  showUploadDocumentModal({ commit }, data) {
    commit("uploadDocDialogue", data);
  },
  showUpdateDocumentModal({ commit }, data) {
    commit("updateDocDialogue", data);
  },
  showDeleteDocumentModal({ commit }, data) {
    commit("deleteDocDialogue", data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
